import { Component } from '@angular/core';
import { MatCardModule } from '@angular/material/card';

@Component({
  selector: 'app-error-landing',
  templateUrl: './error-landing.component.html',
  styleUrls: ['./error-landing.component.scss'],
  standalone: true,
  imports: [
    MatCardModule
  ]
})
export class ErrorLandingComponent {

  readonly images = [
    "assets/images/oops/error1.gif",
    "assets/images/oops/error3.gif",
    "assets/images/oops/error4.gif"
  ];
  
  selectedImage!: string;

  constructor() { }

  ngOnInit(): void {
    this.setRandomImage();
  }

  setRandomImage() {
    const selectedImageIndex = Math.floor(Math.random() * this.images.length);
    this.selectedImage = this.images[selectedImageIndex];     
  }
}